import RecyclingNotificationsPage from "./RecyclingNotifications";

export default RecyclingNotificationsPage;
